import styled from '@emotion/styled';
import theme from '../../styles/theme';
import { StepState } from '../Steps/Steps';
import { rem } from '../../styles/theme/layout';

const StepLine = styled('div')<{ stepState: StepState }>`
  width: 100%;
  height: ${rem(2)};
  background-color: ${({ stepState }) =>
    stepState.isPassed ? theme.colors.gradientGreen : theme.colors.labelGray};
  top: -6%;
  position: relative;
`;

export default StepLine;
